import { defaultFetch } from './baseApi';

export type ProjectType = {
	id: number;
	name: string;
	description: string;
	manager: null;
	cup: string;
	network: true;
	note: string;
	amount: null;
	cuts: null;
	applicant: null;
	hidden: false;
	sco: true;
	editables: {
		cup: false;
		company: false;
		notice: false;
		dnsh: true;
	};
	companyId: number;
	noticeId: number;
	cupType: string;
	streamConfigurationType: string;
	durationInMonths: number;
	oeManagerId: number;
	oeManager: string;
	forecastStartDate: string;
	forecastEndDate: string;
	startDate: null;
	endDate: null;
	businessPlan: true;
	networkNote: string;
	aiEnabled: false;
	locationCode: null;
	finalAmount: null;
	assignedAmount: null;
	totalAdmissibleAmount: null;
	totalApprovedAmount: null;
	indirectCostsPerc: number;
	payrollMgmtModule: false;
	reportableEmployeeDays: null;
	vatRate: null;
	localProjectCode: null;
	projectCodeStamp: null;
	applicantEmail: null;
	dnshMitigationActivityNumber: null;
	dnshAdaptationActivityNumber: null;
	dnshAdaptationActivity: null;
	dnshAdaptationSector: null;
	dnshMitigationActivity: null;
	dnshMitigationSector: null;
	dnshClimateAdaptation: false;
	dnshClimateMitigation: false;
	dnshElement: null;
	createdAt: string;
	updatedAt: string;
	createdBy: number;
	updatedBy: number;
	hasPartnership: true;
	noticeExpenseItems: [
		{
			id: number;
			name: string;
			position: number;
			projectId: number;
			noticeExpenseItemId: number;
			createdAt: string;
			updatedAt: string;
			createdBy: number;
			updatedBy: number;
		},
	];
	advancedConfig: {
		id: number;
		name: string;
		label: string
		description: null | string;
		section: string;
		position: number;
		enabled: boolean;
		entityType: string;
	}[];
	groupids: number[];
	groups: {
		id: number;
		name: string;
		partnership: boolean;
		pivot: {
			projectId: number;
			groupId: number;
		}
	}[];
	samples: string[];
	samplingRuleAssignment: {
		createdAt: string;
		id: number;
		modelId: number;
		modelType: string;
		samplingRule: {
			active: boolean;
			code: string;
			config: null | any;
			createdAt: string;
			createdBy: number;
			description: string;
			id: number;
			name: string;
			strategyClass: string;
			updatedAt: string;
			updatedBy: number;
		};
		samplingRuleId: number;
		updatedAt: string;
	}
	notice: {
		id: number;
		name: string;
		objectives: string | null;
		disbursement: string | null;
		timeframe: string | null;
		compounding: string | null;
		dnsh: number;
		call: string;
		href: {
			action: string;
			url: string;
			entity: string;
		};
		checkliststatus: string | null;
		fund: {
			id: number;
			code: string;
			name: string;
			description: string;
			href: {
				action: string;
				url: string;
				entity: string;
			};
			createdAt: string | null;
			updatedAt: string | null;
			createdBy: number | null;
			updatedBy: number | null;
		};
		institution: {
			id: number;
			code: string;
			name: string;
			href: {
				action: string;
				url: string;
				entity: string;
			};
			managingSystem: string;
			createdAt: string;
			updatedAt: string;
			createdBy: number;
			updatedBy: number;
		};
		checklist: any | null;
		streamConfigurationType: string;
		fundId: number;
		instrumentId: number;
		questionsetId: number;
		publishedAt: string;
		expiresAt: string;
		institutionId: number;
		institutionCode: string;
		admissibleCosts: any | null;
		advancePaymentPercentage: number;
		changeManagement: any | null;
		managingSystem: string | null;
		digitalTagging: number;
		environmentalTagging: number;
		genderEquality: number;
		reportableEmployeeDays: any | null;
		createdAt: string;
		updatedAt: string;
		createdBy: number;
		updatedBy: number;
		enabledConfigs: {
			id: number;
			name: string;
			label: string;
			description: string | null;
			section: string;
			position: number;
			enabled: boolean;
			entityType: string;
			createdAt: string | null;
			updatedAt: string | null;
			createdBy: number;
			updatedBy: number | null;
		}[];
		samplingRuleAssignment: {
			id: number;
			samplingRuleId: number;
			modelType: string;
			modelId: number;
			createdAt: string;
			updatedAt: string;
			samplingRule: {
				id: number;
				name: string;
				code: string;
				description: string;
				config: any | null;
				active: boolean;
				strategyClass: string;
				createdAt: string | null;
				updatedAt: string | null;
				createdBy: number;
				updatedBy: number;
			};
		}
	}
};

export const getProject = async (projectId: string) => {
	return defaultFetch<ProjectType>(`/v0/projects/${projectId}`);
};

export const editProject = (projectId: number, project: Partial<ProjectType>) => {
	return defaultFetch<ProjectType>(`/v0/projects/${projectId}`, {
		method: 'PUT',
		body: JSON.stringify(project),
	});
}
